
<a 
	class="card-link" 
	[routerLink]="article.url"
	queryParamsHandling="merge" 
	[queryParams]="getQueryParams(queryParams, article, orphan)"
>
	<span class="thumbnail">
		<app-media class="card" [alt]="article.title" kind="card" [src]="article.field_image_url"></app-media>
		<app-icon class="type-icon" name="{{article.content_type}}" [shadow]="true"></app-icon>
		<h2 class="page-name" *ngIf="displayPage">{{ article.page_name }}</h2>
	</span>

	<span class="content-wrapper">

		<span class="card-header-wrapper">
			<h2>{{ article.title }}</h2>
			<span class="subtitle" 
				[ngClass]="article.field_logo_1 ? 'logo' : 'no-logo'"
			>
				<app-card-logo 
					class="detail-thumbnail logo-partner" 
					[article]="article" 
				></app-card-logo>
				<h3>{{ article.field_sub_title }}</h3>
			</span>
			
		</span>
		
		<div class="content truncate-overflow" >
			<p>{{ article.summary }}</p>
		</div>
	</span>

	<span class="ripple-container" matRipple></span>
</a>



